export default __webpack_public_path__ + "static/media/familyfriends-header-3.00f8b170.jpg";